import axios from "axios";
import {detailServicesPath} from "../../../Constants";

const detailControllerRestUrl = detailServicesPath + '/customers/orders/'

export default class VariableControllerService {
    static async get(orderId, detailId) {
        const params = orderId === 0 ? "?sample=true" : ""
        return axios.get(`${detailControllerRestUrl}${orderId}/details/${detailId}/variables${params}`);
    }

    static async save(orderId, detailId, data) {
        const params = orderId === 0 ? "?sample=true" : ""
        return await axios.post(`${detailControllerRestUrl}${orderId}/details/${detailId}/variables${params}`, JSON.stringify(data), {
            headers: {
                'Content-Type': 'application/json'
            }
        });
    }

    static async delete(orderId, detailId, variableId) {
        const params = orderId === 0 ? "?sample=true" : ""
        return await axios.delete(`${detailControllerRestUrl}${orderId}/details/${detailId}/variables/${variableId}${params}`, {
            headers: {
                'Content-Type': 'application/json'
            }
        });
    }

    static async edit(orderId, detailId, variableId, data) {
        const params = orderId === 0 ? "?sample=true" : ""
        return await axios.put(`${detailControllerRestUrl}${orderId}/details/${detailId}/variables/${variableId}${params}`, JSON.stringify(data), {
            headers: {
                'Content-Type': 'application/json'
            }
        });
    }

    static async prevAll(detailId, data, orderId) {
        const params = orderId === 0 ? "?sample=true" : ""
        return await axios.post(`${detailControllerRestUrl}${orderId}/details/${detailId}/variables/preview-all${params}`, JSON.stringify(data), {
            headers: {
                'Content-Type': 'application/json'
            }
        });
    }
}
